import { Preferences } from '../types';
import { baseClient } from './client/instance';

const path = 'user-preferences';

export const getPreferences = async () => {
  const response = await baseClient.get<Preferences>(path);
  return response.data;
};

export const updatePreferences = async (
  data: Preferences,
) => {
  const response = await baseClient.put<Preferences>(
    `${path}/update-preferences`,
    { ...data },
  );
  return response.data;
};

export const getCompanySizes = async () => {
  const response = await baseClient.get<string[]>(
    `${path}/choices/company-sizes`,
  );
  return response.data;
};

export const getIndustries = async () => {
  const response = await baseClient.get<string[]>(`${path}/choices/industries`);
  return response.data;
};

export const getCountries = async () => {
  const response = await baseClient.get<string[]>(`${path}/choices/countries`);
  return response.data;
};
